/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_Buyer_NameInputs */

const en_invoice_request_buyer_name = /** @type {(inputs: Invoice_Request_Buyer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name or company`)
};

const pl_invoice_request_buyer_name = /** @type {(inputs: Invoice_Request_Buyer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imię i nazwisko lub firma`)
};

/**
* | output |
* | --- |
* | "Name or company" |
*
* @param {Invoice_Request_Buyer_NameInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_buyer_name = /** @type {((inputs?: Invoice_Request_Buyer_NameInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_Buyer_NameInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_buyer_name(inputs)
	return en_invoice_request_buyer_name(inputs)
});